import {AfterViewInit, Component, ElementRef, HostListener, Input, ViewChild} from '@angular/core';

/**
 * Component to show a tipps slider.
 */
@Component({
    selector: 'app-tipps-slider',
    templateUrl: './tipps-slider.component.html',
    standalone: false
})
export class TippsSliderComponent implements AfterViewInit {

  /**
   * List of tipps we want to show
   */
  @Input() tipps: {name: string, icon: string, url: string}[];

  /**
   * prefix for all texts
   */
  @Input() textPrefix: string;

  /**
   * placeholder fo all texts
   */
  @Input() placeholder: {[key: string]: string} = {}

  /**
   * Hide Button if external Portal
   */
  @Input() hideButton: boolean = false;

  /**
   * The slider element
   */
  @ViewChild('slider') slider: ElementRef;

  /**
   * the slide track element
   */
  @ViewChild('slideTrack') slideTrack: ElementRef;

  /**
   * holds the current visible slide
   */
  currentSlide:number = 0;

  /**
   * holds the slider with
   */
  sliderWidth: number;

  /**
   * Timer for the scroll position update
   */
  scrollTimer: any;

  /**
   * @inheritDoc
   */
  ngAfterViewInit(): void {
    // set the initial slider width, try to avoid race conditions
    setTimeout(() => {
      this.setSliderWidth();
    }, 0)

    // event handler if the slider is scrolled manualy (i.e. swiped)
    this.slideTrack.nativeElement.addEventListener("scroll", () => {
      clearTimeout(this.scrollTimer);
      this.scrollTimer = setTimeout(() => this.updateCurrentSlide(), 100);
    });
  }

  /**
   * Updates the currentSlide index, based on the scroll position of the slide track.
   */
  updateCurrentSlide(): void {
    this.currentSlide = Math.floor(this.slideTrack.nativeElement.scrollLeft / this.sliderWidth);
  }

  /**
   * Updates the slider with to allow easier scrolling
   */
  @HostListener('window:resize')
  setSliderWidth(): void {
    if(this.slider) {
      this.sliderWidth = this.slider.nativeElement.clientWidth;
    }
  }

  /**
   * move to the next slider, if at the end, restart at the beginning.
   */
  next(): void {
    this.currentSlide++;
    if(this.currentSlide === this.tipps.length) {
      this.currentSlide = 0;
    }
    this.slide();
  }

  /**
   * slides one slide back. If at the beginning, move back to the end.
   */
  prev(): void {
    this.currentSlide--;
    if(this.currentSlide < 0) {
      this.currentSlide = this.tipps.length - 1;
    }
    this.slide();
  }

  /**
   * Slides the slider to the current slide index
   */
  slide(): void {
    this.slideTrack.nativeElement.scrollLeft = this.currentSlide * this.sliderWidth;
  }

}
